export default __webpack_public_path__ + "static/media/sauceware-audio-scorch.914aab9a.jpg";